import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { RoleName } from '../entities/user-role-type';

const USER_ROLE_TYPE_URI = '/userRoleType';

export const getUserRoleTypeByName = async (name: RoleName) => {
  return requestApi({
    url: `${USER_ROLE_TYPE_URI}/name/${name}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
